import {PageTemplate} from '../../shared/layout/PageTemplate';
import {CompanyForm} from "./components/CompanyForm";
import {useTranslation} from "react-i18next";

export function Company() {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.company')}`} title={`${t('side_bar.company')}`}
                         content={<CompanyForm/>}/>
}